import type { FaireProductEntity } from "../../entity_types/product";

export const p_qwdhmgztnr: FaireProductEntity = {
  token: "p_qwdhmgztnr",
  type: "product",
  name: "Lucky Tag Love Coin Dainty Chain Layering Necklace set",
  brandToken: "b_4f46qpq5wu",
  brandName: "BestBeads&Beyond",
  imageUrl:
    "https://cdn.faire.com/fastly/54166cf5d16af5b54536c48ff15c5a4b888e2f933e1134a72b63556116ce2f07.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/544a92e2ea774e4e92573d0382e8a4937e3a37d14c8b8e6439378c61c3af6a1c.jpeg",
    "https://cdn.faire.com/fastly/4f0cfa2fe923982f83d2509c31721ae54a94c5ca8a435356f3a1d96bad991a48.jpeg",
  ],
  priceDollars: 15.3,
  description: "\nQty:1pc pack\n\n\nLength:16inch/18inch with extension\n",
  tags: [],
  msrpDollars: 30.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:56.118Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
